export const companyRoutes = [
  {
    path: '/configuracoes/empresa',
    name: 'Company',
    meta: {
      requiresAuth: true,
      menu: true,
      navbarActions: true,
      chat: true,
      path: 'config'
    },
    component: () => import(/* webpackChunkName: 'company-page' */ 'views/CompanyPage')
  }
]
